<template>
    <div v-show="show" class="interviewTable-container">
        <div class="interviewTableContent">
            <div class="top">
                <div class="title">{{title}}</div>
            </div>
            <div :class="{titleline: true, record: true}">
                <span class="num">设备类型</span>
                <span class="name">名称</span>
                <span class="statusType">添加结果</span>
                <span class="reason">原因</span>
            </div>
            <empty :mTop="50" :msg="'暂无数据'" v-if="list && list.length === 0" />
            <div ref="list" class="itemsList" @scroll="getScroll($event)">
                <!-- <template> -->
                    <div class="items" v-for="(resource,index) in list" :key="index">
                        <div :class="{item: true, record: true}">
                            <div class="num">
                                {{resource.type_title}}
                            </div>
                            <div class="name">
                                {{resource.title}}
                            </div>
                            <div :class="{statusType: true, red: !resource.success}">
                                {{resource.success ? '成功' : '失败'}}
                            </div>
                            <div :class="{reason: true, red: !resource.success}">
                                {{resource.info}}
                            </div>
                        </div>
                    </div>
                <!-- </template> -->
            </div>
            <div @click="close" class="btn">确定</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
    components: {
        empty
    },
    watch: {
        value1(to) {
            console.log(to)
        }
    },
    data() {
        return {
            resources: [],
            show: false,
            config: {},
            callback: null,
            title: '批量添加结果',
            value1: '',
            allLoaded: false,
            page: {
                page_count: 0,
                pageSize: 10,
                pageIndex: 1,
                total: 0
            },
            list: [],
            day: 0
        }
    },
    methods: {
        async getScroll(e) {
            // if (e) {
            //     let containerH = 360;
            //     let scrollTop = e.target.scrollTop;
            //     let listHeight = this.$refs.list.offsetHeight;
            //     console.log("getScroll");
            //     if (scrollTop + containerH >= listHeight) {
            //         if (this.allLoaded) {
            //             console.log("进入allLoaded分支");
            //             return e.preventDefault();
            //         } else {
            //             console.log("getScroll 拿分页");
            //             this.page.pageIndex ++
            //             this.getList();
            //         }
            //     }
            // }
        },
        open(config, callback) {
            console.log(config)
            this.config = config;
            this.list = config
            this.callback = callback;
            this.show = true;
        },
        confirm() {
            
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>
<style src="./assets/index.less" lang="less" scoped>

</style>
<style lang="less">
.el-button--text {
    color: #41B48C !important;

    &:hover {
        color: #41B48C !important;
    }
}

.el-button.is-plain:focus, .el-button.is-plain:hover {
    color: #41B48C !important;
    border-color: #41B48C !important;
}
</style>